import { registerCanvasPlugin } from './CanvasPluginRegistry';

/**
 * Registers dynamic CanvasPlugins (Issue #998).
 *
 * Keep all domain imports inside dynamic `import()` loaders so unused domains
 * are not pulled into the initial bundle.
 *
 * Call once at app startup (e.g., `src/react-app/main.tsx`).
 */
export function registerCanvasPlugins(): void {
  registerCanvasPlugin({
    id: 'genogram',
    diagramTypes: ['genogram'],
    loader: async () => {
      const mod = await import('../../domains/genogram/canvas/GenogramCanvasPlugin');
      return new mod.GenogramCanvasPlugin();
    },
  });

  registerCanvasPlugin({
    id: 'orgchart',
    diagramTypes: ['org'],
    loader: async () => {
      const mod = await import('../../domains/orgchart/canvas/OrgChartCanvasPlugin');
      return new mod.OrgChartCanvasPlugin();
    },
  });

  registerCanvasPlugin({
    id: 'flowchart',
    diagramTypes: ['flowchart'],
    loader: async () => {
      const mod = await import('../../domains/process/canvas/FlowchartCanvasPlugin');
      return new mod.FlowchartCanvasPlugin();
    },
  });

  registerCanvasPlugin({
    id: 'network',
    diagramTypes: ['network'],
    loader: async () => {
      const mod = await import('../../domains/network/canvas/NetworkCanvasPlugin');
      return new mod.NetworkCanvasPlugin();
    },
  });

  registerCanvasPlugin({
    id: 'compass',
    diagramTypes: ['network'],
    loader: async () => {
      const mod = await import('../../domains/compass/canvas/CompassCanvasPlugin');
      return new mod.CompassCanvasPlugin();
    },
  });
}

